import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IkonCentang } from "./Ikon";
import { asalNavigasiHp } from "./navigasiHp";

// Toast hitam di atas menu bawah: "<produk> Ditambahkan · Lihat" (papan B1d/B2/B10). Satu toast pada satu waktu, hilang sesudah 2,6 detik.
// Galat tetap lewat toast sonner yang sudah ada (pesan server + tombol WhatsApp batas pcs).
const pendengar = new Set();
let waktu = null;

// teks = string (satu baris), atau { baris1, baris2, sr } = dua baris tombol + kartu (papan "Sesudah tekan +"); sr = nama produk untuk pembaca layar
export function tampilkanToastHp(teks) {
  clearTimeout(waktu);
  pendengar.forEach((f) => f(teks));
  waktu = setTimeout(() => pendengar.forEach((f) => f(null)), 2600);
}

// Keranjang memakai `tanpaLihat` (sudah di keranjang). Posisi = papan: 24 px di atas menu bawah (menu 44 px + max(8 px, safe area)); halaman produk memberi `bawah` sendiri (di atas bar beli)
export function ToastHp({ bawah = 68, tanpaLihat = false }) {
  const lokasi = useLocation();
  const [teks, setTeks] = useState(null);
  useEffect(() => {
    pendengar.add(setTeks);
    return () => { pendengar.delete(setTeks); };
  }, []);
  // Wadah role="status" selalu ada (hanya isinya yang berganti) supaya pembaca layar mengumumkan teksnya
  return (
    <div role="status" aria-live="polite">
      {teks && (
        <div className={`hp-toast${typeof teks === "object" ? " is-dua" : ""}`} style={{ bottom: `calc(${bawah}px + max(8px, env(safe-area-inset-bottom)))` }} data-testid="hp-toast">
          <IkonCentang />
          {typeof teks === "object" ? (
            <span className="hp-toast__dua">
              <span className="hp-sr">{teks.sr}: </span>
              <b data-testid="hp-toast-baris1">{teks.baris1}</b>
              {teks.baris2 && <span data-testid="hp-toast-baris2">{teks.baris2}</span>}
            </span>
          ) : <span className="hp-toast__teks">{teks}</span>}
          {!tanpaLihat && <Link to="/keranjang" state={asalNavigasiHp(lokasi)} className="hp-toast__lihat" data-testid="hp-toast-lihat">Lihat</Link>}
        </div>
      )}
    </div>
  );
}
